// react-redux imports
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/store";

// react-select imports
import { OptionTypeBase } from "react-select";

// styled-components imports
import UserInputSection from "../styled-components/UserInputSection";

// common imports
import Select from "common/components/Select";
import SectionTitle from "common/components/styled-components/SectionTitle";

import { PUBLIC_TRANSPORT_USE_OPTIONS } from "../constants/transport";
import {
  setBusUseWeekly,
  setSubwayUseWeekly,
  setRailwayUseWeekly,
} from "./transportSlice";

function StepTwo() {
  const dispatch = useDispatch();

  const busUseWeekly = useSelector(
    (state: RootState) => state.calculator.transport.busUseWeekly
  );

  const subwayUseWeekly = useSelector(
    (state: RootState) => state.calculator.transport.subwayUseWeekly
  );

  const railwayUseWeekly = useSelector(
    (state: RootState) => state.calculator.transport.railwayUseWeekly
  );

  function handleBusUseChange(option: OptionTypeBase | null) {
    dispatch(setBusUseWeekly(option?.value ?? 0));
  }

  function handleSubwayUseChange(option: OptionTypeBase | null) {
    dispatch(setSubwayUseWeekly(option?.value ?? 0));
  }

  function handleRailwayUseChange(option: OptionTypeBase | null) {
    dispatch(setRailwayUseWeekly(option?.value ?? 0));
  }

  return (
    <>
      <SectionTitle>
        ¿Cuántas veces usas el transporte público a la semana?
      </SectionTitle>
      <UserInputSection>
        <Select
          name={"busUseWeekly"}
          label="Bus"
          isSearchable={false}
          options={PUBLIC_TRANSPORT_USE_OPTIONS}
          placeholder="Selecciona opción"
          value={PUBLIC_TRANSPORT_USE_OPTIONS.find(
            (option) => option.value === busUseWeekly
          )}
          onChange={handleBusUseChange}
          isClearable
        />
        <Select
          name={"subwayUseWeekly"}
          label="Metro"
          isSearchable={false}
          options={PUBLIC_TRANSPORT_USE_OPTIONS}
          placeholder="Selecciona opción"
          value={PUBLIC_TRANSPORT_USE_OPTIONS.find(
            (option) => option.value === subwayUseWeekly
          )}
          onChange={handleSubwayUseChange}
          isClearable
        />
        <Select
          name={"railwayUseWeekly"}
          label="Ferrocarril"
          isSearchable={false}
          options={PUBLIC_TRANSPORT_USE_OPTIONS}
          placeholder="Selecciona opción"
          value={PUBLIC_TRANSPORT_USE_OPTIONS.find(
            (option) => option.value === railwayUseWeekly
          )}
          onChange={handleRailwayUseChange}
          isClearable
        />
      </UserInputSection>
    </>
  );
}

export default StepTwo;
